import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import samplePassport from "../../../assets/visa-requirements/sample-us-passport.png";
import { useNavigate } from "react-router";
import { path } from "../../../utils/common/constant";
import { useTranslation } from "react-i18next";

const VisaRequirementDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">
          {t("visa_requirements_details.title")}
        </h1>
        <p className="text-[22px] font-bold">
          {t("visa_requirements_details.description")}
        </p>
      </div>

      <div className="w-full px-6 py-10 flex flex-col items-center justify-center">
        <div className="w-full max-w-[1290px] flex flex-col justify-center items-center gap-8">
          <p className="text-primary-blue text-3xl font-bold text-center">
            {t("visa_requirements_details.title2")}
          </p>

          <div className="w-full bg-[#8BBDEA]/20 px-8 py-2 justify-center rounded-xl">
            <div className="text-[#074799] text-left font-bold text-base">
              {t("visa_requirements_details.hint")}
            </div>
          </div>

          <p className="text-justify">
            {t("visa_requirements_details.content1")}
          </p>

          <PhotoProvider>
            <PhotoView src={samplePassport}>
              <img
                src={samplePassport}
                alt="sample-passport"
                className="object-cover cursor-pointer"
              />
            </PhotoView>
          </PhotoProvider>

          {/* Section 1 */}
          <p className="w-full text-[22px] text-primary-blue font-bold">
            {t("visa_requirements_details.heading1")}
          </p>
          <p className="text-justify">
            {t("visa_requirements_details.content2")}
          </p>

          <p className="text-justify">
            {t("visa_requirements_details.content3")}
          </p>
          <ul className="list-disc w-full ml-16">
            <li>{t("visa_requirements_details.content3.1")}</li>
            <li>{t("visa_requirements_details.content3.2")}</li>
            <li>{t("visa_requirements_details.content3.3")}</li>
            <li>{t("visa_requirements_details.content3.4")}</li>
          </ul>
          <p className="w-full text-justify">
            {t("visa_requirements_details.content4")}
          </p>
          <ul className="list-disc w-full ml-16">
            <li>{t("visa_requirements_details.content4.1")}</li>
            <li>{t("visa_requirements_details.content4.2")}</li>
            <li>{t("visa_requirements_details.content4.3")}</li>
            <li>{t("visa_requirements_details.content4.4")}</li>
            <li>{t("visa_requirements_details.content4.5")}</li>
          </ul>
          <p className="w-full text-justify">
            {t("visa_requirements_details.content5")}
          </p>

          {/* Section 2 */}
          <p className="w-full text-[22px] text-primary-blue font-bold">
            {t("visa_requirements_details.heading2")}
          </p>
          <p className="text-justify">
            {t("visa_requirements_details.content6")}
          </p>
          <ul className="list-disc w-full ml-16">
            <li>{t("visa_requirements_details.content6.1")}</li>
            <li>{t("visa_requirements_details.content6.2")}</li>
            <li>{t("visa_requirements_details.content6.3")}</li>
            <li>{t("visa_requirements_details.content6.4")}</li>
            <li>{t("visa_requirements_details.content6.5")}</li>
          </ul>

          {/* Section 3 */}
          <p className="w-full text-[22px] text-primary-blue font-bold">
            {t("visa_requirements_details.heading3")}
          </p>
          <p className="text-justify">
            {t("visa_requirements_details.content7")}
          </p>

          <div className="flex w-full justify-center items-center">
            <div className="flex max-sm:flex-col gap-4 mt-8 w-full justify-center items-center text-nowrap">
              <button className="text-sm outline-none w-52 py-5 border font-bold border-primary-blue rounded-full text-primary-blue">
                {t("cta.download")}
              </button>

              <button
                className="text-sm outline-none w-52 py-5 border font-bold border-transparent rounded-full text-primary-blue bg-primary-lightyellow border-primary-lightyellow"
                onClick={() => navigate("../" + path.HOME)}
              >
                {t("cta.back_to_home")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaRequirementDetails;
